export type Order = 'DESC' | 'ASC'

export type Status = 'FAILURE' | 'SUCCESS'

export type EventFormat = 'DOUBLES' | 'SINGLES'

export type Response = {
  status: Status
}

export type Result = {
  offset: number
  limit: number
  total: number
  totalValueRelation?: any
  hasMore: boolean
  hasPrevious: boolean
  empty: boolean
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export type Menu = {
  title: string
  href: string
  icon?: JSX.Element
  public: boolean
}

export type Sponsor = {
  link: string
  message: string
  showBanner: boolean
}

export type Banner = {
  link: string
  message: string
  imageUrl: string
}

export type Role = { id: number; role: string }

export type Content = {
  contentId: number
  header: string
  headerType: string
  content: string
  contentType: string
  footer: string
  footerType: string
}

export enum PlayerGroup {
  MEN = 'MEN',
  WOMEN = 'WOMEN',
  MIXED = 'MIXED',
  OPEN = 'OPEN',
}

export enum MembershipPermission {
  OPEN_TO_ALL = 'OPEN',
  CLUB_MEMBERS = 'CLUB_MEMBERS',
}

export type Country = {
  name: string
  isoCode: string
  dialCode: string
  emoji: string
}

export type TimeZoneOption = {
  value: string
  abbr: string
  label: string
}

export interface Tab {
  [key: string]: {
    tabIsUse: boolean
    isShow?: boolean
  }
}

export type PlayerSponsor = {
  imageURL?: string
  sponsorRedirectUrl?: string
  sponsorPopupHeading?: string
  description?: string
  buttonText?: string
}
